import { Component, Input } from '@angular/core';
import { AppState } from '../../../app.state';

@Component({
  selector: 'upsc-tracking-details',
  templateUrl: './tracking-details.component.html',
  styles: []
})
export class TrackingDetailsComponent {
  @Input() trackingShipmentDetail;
  public readonly userLocale: string;

  constructor(private readonly appState: AppState) {
    switch (this.appState.user$()?.CountryCode) {
      case 'DE': this.userLocale = 'de-DE'; break;
      case 'FR': this.userLocale = 'fr-FR'; break;
      case 'IT': this.userLocale = 'it-IT'; break;
      case 'GB': this.userLocale = 'en-GB'; break;
      default:   this.userLocale = 'en-US';
    }
  }
}
